module.exports = __webpack_public_path__ + "img/icon_wenjianppt.d8dcceb2.svg";